import styled from 'styled-components';
import { Form } from 'react-bootstrap';

export const Check = styled(Form.Check)`
    input {
        margin-top: 8px;
        margin-left: 0 !important;
    }
    label {
        display: block;
    }
`;
